<template>
    <b-form @submit.stop.prevent="submit" class="row g-1">
        <div class="col-md-4">

            <b-form-group label="CEP">
                <input
                    type="tel"
                    v-mask="'#####-###'"
                    placeholder="00000-000"
                    :value="form.zip_code"
                    @input="changeZipCodeInput"
                    class="form-control"
                />
                <has-errors :errors="errors" name="zip_code" />

            </b-form-group>
        </div>
        <!-- Estado -->
        <div class="col-md-4">
            <b-form-group label="Estado">
                <b-form-select
                    v-model="form.state"
                    :options="statesOfBrazil"
                />
                <has-errors :errors="errors" name="state" />

            </b-form-group>
        </div>

        <!-- Cidade -->
        <div class="col-md-4">
            <b-form-group label="Cidade">
                <b-form-input
                    v-model="form.city"
                    placeholder="ex: São Paulo"
                />
                <has-errors :errors="errors" name="city" />

            </b-form-group>
        </div>

        <!-- Endereço -->
        <div class="col-md-7">
            <b-form-group label="Endereço">
                <b-form-input
                    v-model="form.street"
                    placeholder="ex: Av. Paulista"
                />
                <has-errors :errors="errors" name="address" />
                <has-errors :errors="errors" name="street" />

            </b-form-group>
        </div>

        <!-- Número -->
        <div class="col-md-5">
            <b-form-group label="Número">
                <b-form-input
                    v-model="form.number"
                    placeholder="ex: 123"
                />

                <has-errors :errors="errors" name="number" />
            </b-form-group>
        </div>

        <!-- Submit -->
        <div class="col-12" v-if="showButton">
            <b-button type="submit" variant="primary">
                Atualizar
            </b-button>
        </div>
    </b-form>
</template>

<script>
import hasErrors from '../components/HasError.vue'
import cep from '../pages/teacher/pagarme/customer/mixins/cep'

export default {
    components: {
        hasErrors,
    }, 
    props: {
        errors: {
            type: Object,
            default: {}
        },
        address: {
            type: Object,
            default: {
                street: null,
                zip_code: null,
                state: null,
                city: null,
                number: null,
                country: 'BR'
            }
        },
        showButton: {
            default: true
        }
    },
    mixins: [cep],
    data(){
        return {
            loading: false,
            form: this.address ?? {
                street: null,
                zip_code: null,
                state: null,
                city: null,
                number: null,
                country: 'BR'
            },
        }
    },

    methods: {
        submit(){
            this.$emit('submited', this.form);
        }
    }
}
</script>

<style>

</style>